import React, { Component } from 'react';
import './InfluencerMapSelects.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import MapComponent from './MapComponent/MapComponent';
import PrioritiesCurrentComponent from './PrioritiesCurrentComponent/PrioritiesCurrentComponent';
import PrioritiesFutureComponent from './PrioritiesFutureComponent/PrioritiesFutureComponent';
import DisableNextModal from '../../../shared/Common/disableNextModal';

class InfluencerMapSelects  extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            current: false,
            future: false,
            currentData: null,
            futureData: null,
            convaWidth: null,
        };
    }

    componentDidMount(){
        if(this.props.backStep){
            this.props.complitedBackStep();
            let body = {
                projectId: this.props.projectId,
                type: 'influencerMap'
            }
            this.props.getInfluencerMapGroups(body);
        }
        let width = document.getElementById('banner-contenedor').offsetWidth
        this.setState({convaWidth: width});

        // let body = {
        //     projectId: this.props.projectId,
        //     type: 'influencerMap'
        // }
        // this.props.getInfluencerMapGroups(body);
        //  debugger
    }

    componentWillReceiveProps(nextProps){
        if (this.props.addInfluencerMapGroupsData !== nextProps.addInfluencerMapGroupsData) {
            let body = {
                projectId: this.props.projectId,
                type: 'influencerMap'
            }
            this.props.getInfluencerMapGroups(body);
        }
        if(nextProps.getInfluencerMapGroupsData.Items[0].priorities && !this.state.getData){
            this.setState({ getData : true })
            this.validateFuture(nextProps.getInfluencerMapGroupsData.Items[0].priorities.future, 'exist');

            this.validateCurrent(nextProps.getInfluencerMapGroupsData.Items[0].priorities.current, 'exist')

        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    craetePrioritiesArr = (type, value) => {

    }

    validateFuture = (data, exist) => {
        let future = []
        if(exist){
            data[0] && future.push(data[0]);
            data[1] && future.push(data[1]);
            data[2] && future.push(data[2]);
        }else {
            data.first !== '' && future.push(data.first);
            data.second !== '' && future.push(data.second);
            data.third !== '' && future.push(data.third);
        }

        if( (_.uniq(future).length === future.length)  && ( future.length > 0 ) ){
            this.setState({ future : true, futureData: future  });
        } else {
            this.setState({ future : false, futureData: null });
        }

    }

    validateCurrent = (data, exist) => {
        let current = []
        if(exist){
            data[0] && current.push(data[0]);
            data[1] && current.push(data[1]);
            data[2] && current.push(data[2]);
        }else {
            data.first !== '' && current.push(data.first);
            data.second !== '' && current.push(data.second);
            data.third !== '' && current.push(data.third);
        }
        if( (_.uniq(current).length === current.length) && ( current.length > 0) ){
            this.setState({ current : true, currentData: current  });
        } else {
            this.setState({ current : false, currentData: null });
        }

    }

    nextStep = () => {
        if( this.state.future && this.state.current ){
            let body = {
                projectId: this.props.projectId,
                type : 'influencerMap',
                id : this.props.getInfluencerMapGroupsData.Items[0].id,
                groups : this.props.getInfluencerMapGroupsData.Items[0].groups,
                groupsMap: this.props.getInfluencerMapGroupsData.Items[0].groupsMap,
                priorities: {
                    current: this.state.currentData,
                    future: this.state.futureData,
                },
                status: 'finished',
            }

            this.props.editInfluencerMapGroups(body);
            this.props.groupStateNext();
        }else{
            this.props.disableNextModal()
        }
    }

    render() {

        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-six arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-six arrow-step active-step'>
                        <p>Step 5</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-lg-7">
                        <h5>Influencer Map</h5>
                      </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className='card'>
                                <div className='card-header'>
                                    <h5>Analyze the map</h5>
                                    <span>Indicate what your top 3 priority Customer Groups were before conducting this analysis – and what your top 3 are now</span>
                                </div>
                                <div className='card-body'>
                                    <div className='row'>

                                        {this.props.getInfluencerMapGroupsData.Items[0].groups &&
                                            <div className='select-menu-canvas'>
                                                <PrioritiesCurrentComponent
                                                    craetePrioritiesArr={this.craetePrioritiesArr}
                                                    validateCurrent={this.validateCurrent}
                                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                />
                                                <PrioritiesFutureComponent
                                                    craetePrioritiesArr={this.craetePrioritiesArr}
                                                    validateFuture={this.validateFuture}
                                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                />
                                            </div>
                                        }

                                        {/* <div className='col-sm-10'  style={{overflow: "scroll"}}> */}
                                        <div className="canvas-card" style={{overflow: "scroll"}}>
                                            <div className='canvas-content' id="banner-contenedor">
                                                { !_.isEmpty(this.props.getInfluencerMapGroupsData)  &&
                                                    <MapComponent
                                                        getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                        convaWidth={this.state.convaWidth}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='btn btn-success' onClick={this.nextStep}>Next</div>
                                    <div className='btn empty-btn default' onClick={this.props.groupStateBack}>Back</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                { this.props.disableNextState &&
                    <DisableNextModal
                        disableNextState={this.props.disableNextState}
                        disableNextModal={this.props.disableNextModal}
                        disableModalText='Priorites of the "current" column are not unique'
                        disableModalTitle='Customer Group Priorities'
                    />

                }
            </div>
        )
    }
}

export default (InfluencerMapSelects);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/InfluencerMapSelects/InfluencerMapSelects.jsx